import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const getRequest = (data: any) => {
  return {
    entityId: data?.entityID,
    id: data?.id,
    status: String(data?.status),
  }
}

const responseParser = (response: any) => {
  return isSuccessResponse(response)
}

const updateCardMapping = (data: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.updateCardMapping),
    method: 'POST',
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      ...getRequest(data),
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { updateCardMapping }
